import { FunctionComponent } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { IOpenLinkButtonProps } from './OpenLinkButton.interface';

const StyledIconButton = styled(IconButton)<IconButtonProps | LinkProps>(({ theme }) => ({
  color: theme.palette.text.disabled,
  '&:hover': {
    color: theme.palette.primary[theme.palette.mode],
  },
}));

export const OpenLinkButton: FunctionComponent<IOpenLinkButtonProps> = ({ href, onClick, sx }) => {
  return (
    <StyledIconButton
      onClick={onClick}
      aria-label={'open link'}
      size={'small'}
      component={Link}
      to={href}
      target={'_blank'}
      sx={sx}
    >
      <OpenInNewIcon />
    </StyledIconButton>
  );
};
